var messages = {
  cancelText: 'キャンセル',
  justOkText: '完了',
  okText: 'はい',
  rejectText: 'いいえ'
};
export default messages;